import type { CSSProperties, ReactNode } from 'react';

interface StatisticsRowProps {
  children?: ReactNode;
  /** Additional CSS classes to apply to the row container. */
  className?: string;
  /** Optional inline styles to apply to the row container. */
  style?: CSSProperties;
}

export default function StatisticsRow({ className = '', children, style }: StatisticsRowProps) {
  return (
    <div className={`flex justify-between items-center gap-[8px] ${className}`} style={style}>
      {children}
    </div>
  );
}
